import { dateToFirestoreTimestamp as _dateToFirestoreTimestamp } from '@griply/services';
import { ConvertDates } from '@griply/types';
import { Timestamp } from 'firebase/firestore';

// Wrapper to bind Firebase SDK Timestamp.fromDate to packages version
export const dateToFirestoreTimestamp = <T>(
  obj: T,
): ConvertDates<T, Timestamp> =>
  _dateToFirestoreTimestamp(obj, Timestamp.fromDate);
